import { bugsnag } from './bugsnag';
import posthog from 'posthog-js';

export interface ErrorMetadata {
	[key: string]: unknown;
}

/**
 * Enhanced error handler that better handles object serialization and provides typing
 * @param error Error object or message
 * @param metadata Additional context about the error
 */
export function errorHandler(error: Error | string, metadata?: ErrorMetadata): void {
	const errorObject = error instanceof Error ? error : new Error(error);

	const processedMetadata: ErrorMetadata = {};

	if (metadata) {
		Object.entries(metadata).forEach(([key, value]) => {
			if (value === undefined || value === null) {
				return;
			}

			try {
				if (typeof value === 'object') {
					processedMetadata[key] = JSON.stringify(value);
				} else {
					processedMetadata[key] = value;
				}
			} catch (err) {
				processedMetadata[key] = String(value);
			}
		});
	}

	processedMetadata.timestamp = new Date().toISOString();
	processedMetadata.environment = import.meta.env.MODE;
	processedMetadata.sessionId = posthog?.get_session_id();

	bugsnag.notify(errorObject, (report) => {
		report.addMetadata('errorContext', processedMetadata);
	});
}
